<div fxFlex class="p-10" style="width: 100%; height: 100%; display: flex; flex-direction: column; flex-grow: 1; overflow: hidden">
    <mat-card appearance="outlined" style="width: 100%; padding: 20px; max-height: 100%; overflow: hidden">
        <div style="display: flex; height: 50%; width: 100%; flex-direction: column">
            <div fxFlex fxLayout="row">
                <div style="margin-right: 10px; font-size: medium; font-weight: bold">{{ aircraft?.registrationMark }}:</div>
                <div style="margin-right: 10px; font-size: medium">Aircraft Current Total Hours: {{ totalHours || 0 }}</div>
                @if (showFlightNumber) {
                    <div style="margin-right: 10px; font-size: medium">Last Flight Number: {{ helicopterData?.flightNumber || 0 }}</div>
                }
                <div style="font-size: medium">Aircraft Current Total Cycles: {{ totalCycles || 0 }}</div>
            </div>
            <div fxFlex>
                <div fxFlex fxLayoutGap="10px" style="margin-top: 20px; margin-bottom: 20px">
                    @if (isCamo) {
                        <button mat-raised-button color="primary" (click)="openCreateHoldItemListDialog()" style="font-size: 14px !important; font-weight: 500; margin-right: 10px">
                            Add new item
                        </button>
                    }
                    @if (isCamo) {
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="openNewExpiringDialog()"
                            style="font-size: 14px !important; font-weight: 500"
                            [disabled]="!showAddExceptionBtn"
                        >
                            Add new Expiring
                        </button>
                    }
                    <mat-checkbox [(ngModel)]="showOpenItems" (change)="applyOpenItemsFilter()">Show only open inspections</mat-checkbox>
                </div>
                <div fxFlex="10" fxFlexFill fxLayoutAlign="center center">
                    <button mat-raised-button color="primary" [disabled]="data.length === 0" (click)="excel.save()">
                        <mat-icon>download</mat-icon>
                        Export
                    </button>
                </div>
                <div fxFlex="20" fxLayout="column" fxFlexFill>
                    <mat-form-field fxFlex class="mr-10">
                        <mat-label>ATL Block Number</mat-label>
                        <mat-select name="htlBlockNumber" (selectionChange)="onHtlBlockNumberChange($event)" [(ngModel)]="htlBlockNumber">
                            <mat-option [value]="-1">All</mat-option>
                            @for (block of htlBlockNumberArray; track block) {
                                <mat-option [value]="block.id"> Nr. {{ block.blockNumber }} </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-grow: 1; flex-direction: column; overflow: auto; height: auto; height: 100%">
            <kendo-grid
                #grid="kendoGrid"
                style="height: 100%; width: 100%"
                [kendoGridBinding]="data"
                [data]="gridView"
                [filterable]="'menu'"
                [sort]="state.sort"
                [sortable]="true"
                [scrollable]="'scrollable'"
                [selectable]="{ enabled: true, checkboxOnly: true, mode: 'single' }"
                [resizable]="true"
                (selectionChange)="onSelectionChange($event)"
                (dataStateChange)="dataStateChange($event)"
                (excelExport)="excelExportData($event)"
                [pageSize]="state.take"
                [pageable]="{
                    info: true,
                    type: 'numeric',
                    buttonCount: 8,
                    position: 'bottom',
                    previousNext: true,
                    pageSizes: pageSizes,
                }"
            >
                <kendo-grid-checkbox-column [width]="50"></kendo-grid-checkbox-column>
                @for (col of gridColumns; track col.field) {
                    @if (col.isGroup && !col.disabled) {
                        <kendo-grid-column-group title="{{ col.title }}">
                            @for (subCol of col.cols; track subCol.field) {
                                @if (!subCol.disabled) {
                                    <kendo-grid-column field="{{ subCol.field }}" title="{{ subCol.title }}" [width]="subCol.width">
                                        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                                            <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService">
                                                <kendo-filter-contains-operator></kendo-filter-contains-operator>
                                                <kendo-filter-notcontains-operator></kendo-filter-notcontains-operator>
                                                <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                                <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                                <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
                                                <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
                                            </kendo-grid-string-filter-menu> </ng-template
                                    ></kendo-grid-column>
                                }
                            }
                        </kendo-grid-column-group>
                    } @else if (!col.disabled) {
                        <kendo-grid-column field="{{ col.field }}" title="{{ col.title }}" [width]="col.width">
                            <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                                <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService">
                                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                                    <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
                                    <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                    <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                    <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
                                    <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
                                </kendo-grid-string-filter-menu> </ng-template
                        ></kendo-grid-column>
                    }
                }
            </kendo-grid>
            <kendo-excelexport #excel [fileName]="filename" [data]="data">
                @let matPrimaryColor = "#4050b5";
                @for (col of gridColumns; track col.field) {
                    @if (col.isGroup) {
                        <kendo-excelexport-column-group title="{{ col.title }}" [headerCellOptions]="{ background: matPrimaryColor }">
                            @for (subCol of col.cols; track subCol.field) {
                                <kendo-excelexport-column
                                    field="{{ subCol.field }}"
                                    title="{{ subCol.title }}"
                                    [width]="subCol.width"
                                    [headerCellOptions]="{ background: matPrimaryColor }"
                                ></kendo-excelexport-column>
                            }
                        </kendo-excelexport-column-group>
                    } @else {
                        <kendo-excelexport-column
                            field="{{ col.field }}"
                            title="{{ col.title }}"
                            [width]="col.width"
                            [headerCellOptions]="{ background: matPrimaryColor }"
                        ></kendo-excelexport-column>
                    }
                }
            </kendo-excelexport>
        </div>
    </mat-card>
</div>
